import React, { ReactNode, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Logger } from '@futrli/shared-services';
import { WorkspaceMember } from '@futrli-sdk/people';

import { fetchMembersInOrganisation } from '../core/api/members';
import { createContext } from '../core/context';
import { usePredictionsInfoContext } from '../forecast/detail/context/predictions-info-context';

interface Props {
  children: ReactNode;
}

interface MembersContextProps {
  members: WorkspaceMember[];
  isLoading: boolean;
}

const MembersContext = createContext<MembersContextProps>();

export const MembersContextProvider = ({ children }: Props) => {
  const [members, setMembers] = useState<WorkspaceMember[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { isConsolidation } = usePredictionsInfoContext();

  const { workspaceId: tempWorkspaceId, organisationId: tempOrganisationId } = useParams();

  const workspaceId = tempWorkspaceId || '';
  const organisationId = tempOrganisationId || '';

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const fetchedMembers = await fetchMembersInOrganisation(workspaceId, organisationId, isConsolidation);
        setMembers(fetchedMembers);
      } catch (e) {
        Logger.error(e as string);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [workspaceId, organisationId, isConsolidation]);

  return <MembersContext.Provider value={{ members, isLoading }}>{children}</MembersContext.Provider>;
};

export const useMembersContext = MembersContext.useContext;
